export const ARIYA = "ARIYA";
export const QASHQAI_2021 = "Qashqai 2021";
export const AURA = "Aura";
export const SAKURA = "Sakura";
